import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AddDashboardRequest, CloneDashboardRequest, PatchDashboardRequest } from 'src/app/types/request/dashboard.req';
import { DashboardDto, DashboardsDto } from 'src/app/types/dto/dashboard.types.dto';
import { environment } from 'src/environments/environment';
import { HttpHelperService } from '../http.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardApiService {
  private http = inject(HttpClient);
  private httpHelper = inject(HttpHelperService);


  appBaseURL = environment.apiUrl + 'dash-boards/';

  getDashboards(): Observable<DashboardsDto> {
    return this.http.get<DashboardsDto>(
      this.appBaseURL,
      this.httpHelper.httpReadOnlyOptions);
  }

  /** fromPrimary skips the read-only replica, which can lag behind; use it when the result feeds a save */
  getDashboard(dashBoardId: number, fromPrimary = false): Observable<DashboardDto> {
    return this.http.get<DashboardDto>(
      this.appBaseURL + dashBoardId,
      fromPrimary ? this.httpHelper.httpOptions : this.httpHelper.httpReadOnlyOptions);
  }

  editDashboard(id: number, req: PatchDashboardRequest): Observable<DashboardDto> {
    return this.http.patch<DashboardDto>(
      this.appBaseURL + id,
      req,
      this.httpHelper.httpOptions);
  }

  addDashboard(req: AddDashboardRequest): Observable<DashboardDto> {
    return this.http.post<DashboardDto>(
      this.appBaseURL,
      req,
      this.httpHelper.httpOptions);
  }

  cloneDashboard(req: CloneDashboardRequest): Observable<DashboardDto> {
    return this.http.post<DashboardDto>(
      this.appBaseURL + 'clone',
      req,
      this.httpHelper.httpOptions);
  }

  deleteDashboard(dashBoardId: number) {
    return this.http.delete(
      this.appBaseURL + dashBoardId,
      this.httpHelper.httpOptions);
  }

  setDefaultDashboard(dashBoardId: number, isDefault: boolean) {
    return this.http.patch(
      this.appBaseURL + dashBoardId + '/default',
      { isDefault: isDefault },
      this.httpHelper.httpOptions);
  }
}
